module.exports = __webpack_public_path__ + "static/media/white_you.b31a5151.png";